import { LogLevel } from "@azure/msal-browser";
import { MICROSOFT_CLIENT_ID, MICROSOFT_REDIRECT_URL } from "@env";
export const msalConfig = {
  auth: {
    clientId: MICROSOFT_CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: MICROSOFT_REDIRECT_URL,
    postLogoutRedirectUri: "/",
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
  system: {
    loggerOptions: {
      loggerCallback: (level :any, message :any, containsPii :any)  => {
        if (containsPii) {
          return;
        }
        switch (level) {
        case LogLevel.Error:
          // console.error(message);
          return;
        case LogLevel.Info:
          //console.info(message);
          return;
        case LogLevel.Verbose:
          //console.debug(message);
          return;
        case LogLevel.Warning:
          //console.warn(message);
          return;
        default:
          return;
        }
      },
    },
  },
};
